import type {AssetStoryblok} from '../types/storyblok';

export function sbAssetUrl(asset: AssetStoryblok | string | undefined): string | undefined {
  const url = typeof asset === 'string' ? asset : asset?.filename;

  return url?.replace(/^https?:\/\/a.storyblok.com\//, '/_assets/');
}

export function sbAssetType(asset: AssetStoryblok | undefined): 'image' | 'video' | 'unknown' {
  if (!asset) {
    return 'unknown';
  }

  if (asset.filename.match(/\.(webp|gif|jpg|jpeg|png|avif|svg)$/i)) {
    return 'image';
  }

  if (asset.filename.match(/\.(mp4|webm)$/i)) {
    return 'video';
  }

  return 'unknown';
}
